import React, { useState, useContext } from 'react';
import classnames from 'classnames';
import DiscoveryContext from '@/contexts/discoveryContext/contextV2';
import {
  checkboxOption,
  checkBoxIcon,
  checkBoxIconActive,
} from '../styles.module.css';

const CovidSelect = ({ update }) => {
  const {
    filters: {
      covid: { covidOnly },
    },
  } = useContext(DiscoveryContext);

  const [covidSelected, setCovidSelected] = useState(covidOnly);

  const onToggle = () => {
    setCovidSelected(!covidSelected);
    update({
      covid: !covidSelected ? true : undefined,
    });
  };

  return (
    <div>
      <div
        className={checkboxOption}
        onClick={() => onToggle()}
        onKeyPress={() => onToggle()}
      >
        <span
          className={classnames(checkBoxIcon, {
            [checkBoxIconActive]: covidSelected,
          })}
        ></span>
        <span>Covid-19 Planned Races Only</span>
      </div>
    </div>
  );
};

export default CovidSelect;
